export class RowStyle {
  columnGap = 'uk-grid-collapse';
  maxWidth = '';
  columnDividers = '';
  margin = 'uk-margin-remove-vertical';
  removeTopMargin = '';
  removeBottomMargin = '';
  contentAlignment = '';
  visibility = '';

  static normalize(styles: Partial<RowStyle>): RowStyle {
    const pureStyles = new RowStyle();

    pureStyles.columnGap = styles.columnGap ?? pureStyles.columnGap;
    pureStyles.maxWidth = styles.maxWidth ?? pureStyles.maxWidth;
    pureStyles.columnDividers = styles.columnDividers ?? pureStyles.columnDividers;
    pureStyles.margin = styles.margin ?? pureStyles.margin;
    pureStyles.removeTopMargin = styles.removeTopMargin ?? pureStyles.removeTopMargin;
    pureStyles.removeBottomMargin = styles.removeBottomMargin ?? pureStyles.removeBottomMargin;
    pureStyles.contentAlignment = styles.contentAlignment ?? pureStyles.contentAlignment;
    pureStyles.visibility = styles.visibility ?? pureStyles.visibility;

    return pureStyles;
  }
}
